if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"WPPOpenCoreOS","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2345|2992|3543|396|8579|887|9228)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}